import { render } from "./CmpFooter.vue?vue&type=template&id=62c5c987&scoped=true&ts=true"
import script from "./CmpFooter.vue?vue&type=script&lang=ts"
export * from "./CmpFooter.vue?vue&type=script&lang=ts"

import "./CmpFooter.vue?vue&type=style&index=0&id=62c5c987&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c5c987"]])

export default __exports__